import dateUtils from "@/utils/date";

export const useEtatPanier = (etatPanier) => {
  const status = computed(() => {
    return etatPanier.type;
  })
  const produits = computed(() => {
    return etatPanier.apiResult.itemsMergeResult.newItems;
  })
  const dateLastUsage = computed(() => {
    return dateUtils.formatDateTime(
      etatPanier.apiResult.infoPanierDB.dateLastUsage
    );
  })
  const dateLastUpdate = computed(() => {
    return dateUtils.formatDateTime(
      etatPanier.apiResult.dateLastUpdate
    );
  })

  return { status, produits, dateLastUsage, dateLastUpdate }
}